import { render, staticRenderFns } from "./MyVuetable.vue?vue&type=template&id=84089b60"
import script from "./MyVuetable.vue?vue&type=script&lang=js"
export * from "./MyVuetable.vue?vue&type=script&lang=js"
import style0 from "./MyVuetable.vue?vue&type=style&index=0&id=84089b60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports